import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {baseUrl} from '@/config/env';




export const tabulateOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    //menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "经销商名称",
            prop: "dealerName",
            type: "input",
            search:true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '经销商账号',
            prop: 'account',
            search:true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '店铺名称',
            prop: 'shopName',
            search:true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '总库存',
            prop: 'number',
            addVisdiplay: false,
            editVisdiplay: false
        }
    ]
};